import WidgetControlWrapperNew from './WidgetControlWrapperNew';
import WidgetControlWrapperContainerNew from './WidgetControlWrapperContainerNew';

export default WidgetControlWrapperContainerNew;
export { WidgetControlWrapperNew };
